import {load} from '@shopify/theme-sections';
import '@/scripts/sections/product';
import Filter from '@/scripts/components/Filter';
import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic';
import {TweenMax} from 'gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
import {getCssVar} from '@/scripts/utils/helpers';
import {openCart} from '@/scripts/sections/minicartHelpers'

load('*');

const selectors = {
    imageText: '.image-with-text',
    trigger: '.trigger-element',
    imageWithTextImg: '.image-with-text__image img',
    homeHeroBG: '#home__hero__background',
    shopItems: '.shop-item',
};

const classes = {
    hoverClass: 'hover'
}

$(document).ready(() => new Index()); // eslint-disable-line no-use-before-define

class Index {

    initMediaQuery = () => {
        const small = getCssVar('small') || '750px';
        const medium = getCssVar('medium') || '1040px';
        this.desktopMq = window.matchMedia(`(min-width: ${small})`);
        this.mediumMq = window.matchMedia(`(min-width: ${medium})`);
    };

    setUpShop = () => {
        if (this.mediumMq.matches) {
            let $shopItems = $(selectors.shopItems);
            $shopItems.mouseenter(function (e) {
                $shopItems.removeClass(classes.hoverClass);
                $(e.target).closest(selectors.shopItems).addClass(classes.hoverClass);
            });
        }
    }

    indexAnimations = () => {
        const controller = new ScrollMagic.Controller();

        if (document.getElementById('home-filter-title')) {
            const scene1 = new ScrollMagic.Scene({
                triggerElement: '#home-filter-title',
                triggerHook: .5,
                offset: -100,
                reverse: false
            })
                .setClassToggle('#home-filter-title', 'fade-in')
                .addTo(controller);
        }

        if (document.getElementById('home-filter-select')) {
            const scene2 = new ScrollMagic.Scene({
                triggerElement: '#home-filter-select',
                triggerHook: .5,
                offset: -100,
                reverse: false
            })
                .setClassToggle('#home-filter-select', 'fade-in')
                .addTo(controller);
        }

        if (document.querySelector('.discovery__container')) {
            const scene3 = new ScrollMagic.Scene({
                triggerElement: '.discovery__container',
                triggerHook: 1,
                offset: 100,
                reverse: false
            })
                .setClassToggle('.discovery__container', 'fade-in')
                .addTo(controller);
        }

        if (document.getElementById('hero-triggerhook')) {
            const scene4 = new ScrollMagic.Scene({
                triggerElement: '#hero-triggerhook',
                triggerHook: 0
            });

            if (document.getElementById('home-fixed-scroll')) {
                scene4.setClassToggle('#home-fixed-scroll', 'relative')
            }

            scene4.addTo(controller);

            const scene4b = new ScrollMagic.Scene({
                triggerElement: '#hero-triggerhook',
                triggerHook: 0,
                offset: -40,
            });

            if (document.getElementById('home-fixed-scroll')) {
                scene4b.setClassToggle('#home-fixed-scroll', 'text-revealed')
            }

            scene4b.addTo(controller);

            const sceneBackgroundCover = new ScrollMagic.Scene({
                triggerElement: '#hero-triggerhook',
                triggerHook: 0.8,
            });

            if (document.getElementById('home-fixed-cover')) {
                sceneBackgroundCover.setClassToggle('#home-fixed-cover', 'hidden')
            }

            sceneBackgroundCover.addTo(controller);
        }

        if (document.getElementById('home-discovery')) {
            const scene5 = new ScrollMagic.Scene({
                triggerElement: '#home-discovery',
                triggerHook: 1
            })
                .setClassToggle('.footer', 'relative')
                .addTo(controller);
        }

        if (document.getElementById('home__shop')) {
            const moveShop = TweenMax.fromTo('#home__shop', 1, {
                transform: 'translateY(0px)',
                opacity: 1
            }, {
                transform: 'translateY(-80px)',
                opacity: .01,
                ease: Circ.easeIn
            });
        }

        if (document.getElementById('home-discovery')) {
            const scene6 = new ScrollMagic.Scene({
                triggerElement: '#home-discovery',
                triggerHook: '1'
            })
                .setTween(moveShop)
                .addTo(controller);
        }

        if (document.getElementById('home-story')) {
            const scene7 = new ScrollMagic.Scene({
                triggerElement: '#home-story',
                triggerHook: 1,
                offset: 100,
                reverse: false
            })
                .setClassToggle('#home-story', 'fade-in')
                .addTo(controller);
        }

        if (document.querySelector('.shop-item__bg')) {
            const moveShopImages = TweenMax.fromTo('.shop-item__bg', 1, {
                backgroundPositionY: '100%'
            }, {
                backgroundPositionY: '50%',
                ease: Circ.easeIn
            });

            if (document.getElementById('hero-triggerhook')) {
                const scene9 = new ScrollMagic.Scene({
                    triggerElement: '#hero-triggerhook',
                    duration: '100%',
                    triggerHook: '1',
                }).setTween(moveShopImages).addTo(controller);
            }
        }

        if (document.getElementById('home-filter-select')) {
            const scene8 = new ScrollMagic.Scene({
                triggerElement: '#home-filter-select',
                triggerHook: 0.85,
                offset: 200,
                reverse: false
            })
                .setClassToggle('#home-filter-bottles', 'fade-in')
                .addTo(controller);
        }
    };

    openCartOnUrlParams = () => {
        if (!window.URLSearchParams) {
            // console.warn('does not work in IE11');
            return;
        }

        const searchParams = new window.URLSearchParams(window.location.search);

        if (searchParams.get('cart') === 'open') {
            openCart();
            window.history.replaceState({
                id: 'homepage',
            }, 'Henry Rose: 100% Transparent Fine Fragrances', '/');
        }
    };

    setUpFilter = () => {
        new Filter();
    };

    constructor() {
        this.openCartOnUrlParams();
        this.initMediaQuery();
        this.indexAnimations();
        this.setUpFilter();
        this.setUpShop();
    }
}
